var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGridImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1083_126755)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 26.7292,
    width: 26.7293,
    height: 26.7293,
    transform: "rotate(-90 4 26.7292)",
    fill: "#475F5E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81641 7.1189L8.53083 7.43034L8.53083 7.38937C8.02464 8.03333 7.6379 8.76353 7.38892 9.54507L7.23389 9.97949L7.28288 9.52869C7.34503 8.67894 7.55485 7.84671 7.90282 7.06972L7.90282 7.02872L8.10675 6.65169C8.13246 6.60432 8.16712 6.56251 8.20891 6.52864C8.2507 6.49477 8.2987 6.4695 8.35021 6.45428C8.40171 6.43905 8.45574 6.43417 8.50912 6.43992C8.56251 6.44566 8.61424 6.46191 8.66137 6.48774C8.70851 6.51358 8.75014 6.54849 8.78385 6.59048C8.81755 6.63247 8.84268 6.68072 8.85783 6.73248C8.87298 6.78424 8.87779 6.83848 8.87207 6.89212C8.86636 6.94576 8.85018 6.99777 8.82447 7.04513L8.81641 7.1189Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.062 3.33157C12.9753 3.5142 11.9595 3.99339 11.1255 4.7168C11.4645 4.25712 11.8559 3.83898 12.2919 3.47093C12.7514 3.11287 13.2494 2.80771 13.7765 2.56112C13.8253 2.52708 13.8807 2.50391 13.939 2.49318C13.9974 2.48245 14.0575 2.48439 14.1151 2.49888C14.1727 2.51338 14.2265 2.54008 14.2729 2.5772C14.3194 2.61433 14.3573 2.66102 14.3843 2.71413C14.4113 2.76724 14.4268 2.82555 14.4295 2.88512C14.4323 2.9447 14.4223 3.00417 14.4003 3.05955C14.3782 3.11493 14.3446 3.16494 14.3018 3.2062C14.2589 3.24747 14.2077 3.27905 14.1517 3.29881C14.1517 3.29881 14.0946 3.32338 14.062 3.33157Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.498 3.34798L20.1228 3.20045C19.3674 2.88496 18.5588 2.718 17.7409 2.70865L17.333 2.75783L17.7164 2.61029C18.5719 2.40818 19.4585 2.37476 20.3267 2.51191L20.7264 2.56112C20.8355 2.57542 20.9346 2.63261 21.0019 2.72018C21.0692 2.80775 21.0991 2.91855 21.0852 3.0283C21.0793 3.082 21.0626 3.13393 21.0361 3.18099C21.0097 3.22804 20.9741 3.26927 20.9315 3.30218C20.8888 3.33509 20.84 3.35899 20.7879 3.37249C20.7358 3.386 20.6817 3.38883 20.6285 3.38077C20.5835 3.37718 20.5393 3.36609 20.498 3.34798Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7425 7.14297C25.5793 6.90527 25.4406 6.65937 25.3019 6.45446C25.1443 6.24097 24.9726 6.03831 24.788 5.84789C24.3999 5.45775 23.9704 5.11145 23.5073 4.81514C24.0431 4.99522 24.5574 5.23437 25.0409 5.52824C25.2868 5.68003 25.5214 5.84989 25.7425 6.03642C25.9708 6.23314 26.1665 6.43805 26.3705 6.61837C26.4457 6.69636 26.4879 6.80073 26.4879 6.90936C26.4879 7.01799 26.4457 7.12233 26.3705 7.20032C26.2925 7.27841 26.1869 7.32227 26.0768 7.32227C25.9667 7.32227 25.8612 7.27841 25.7832 7.20032C25.7572 7.17983 25.7352 7.15485 25.718 7.12656L25.7425 7.14297Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7007 13.3235L27.7497 12.9136C27.7583 12.7854 27.7583 12.6567 27.7497 12.5284C27.7469 12.2543 27.7278 11.9806 27.6925 11.7087C27.6608 11.4327 27.6118 11.1589 27.5457 10.8891C27.4755 10.6077 27.38 10.3334 27.2603 10.0694C27.4392 10.2893 27.5975 10.5252 27.7333 10.7743C27.8707 11.0394 27.9906 11.3132 28.0923 11.594C28.1902 11.8645 28.2799 12.135 28.3533 12.4136C28.3962 12.5615 28.4289 12.7121 28.4512 12.8645L28.5001 13.2907C28.5082 13.3441 28.5053 13.3986 28.4919 13.4509C28.4784 13.5032 28.4546 13.5523 28.4219 13.5952C28.3891 13.638 28.3481 13.6738 28.3013 13.7003C28.2545 13.7269 28.2028 13.7437 28.1493 13.7497C28.0414 13.7638 27.9322 13.7347 27.8452 13.6688C27.7583 13.603 27.7006 13.5055 27.6844 13.3972L27.7007 13.3235Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7023 19.5117L25.9389 19.1921L25.9389 19.1347C26.2171 18.8672 26.4438 18.5504 26.6077 18.2003C26.7897 17.8273 26.9504 17.4441 27.089 17.0528L27.1869 16.6675L27.1869 17.0691C27.1496 17.4965 27.0842 17.9209 26.9911 18.3396C26.8977 18.7895 26.7265 19.2195 26.4854 19.6101L26.4854 19.5527L26.3386 19.9216C26.2954 20.0218 26.2149 20.1011 26.1143 20.1425C26.0136 20.1838 25.9009 20.184 25.8002 20.1429C25.7501 20.1222 25.7046 20.0918 25.6663 20.0533C25.628 20.0149 25.5978 19.9691 25.5773 19.9188C25.5568 19.8684 25.5464 19.8144 25.5469 19.76C25.5474 19.7056 25.5586 19.6519 25.5799 19.6019C25.5933 19.5794 25.6111 19.5599 25.6321 19.5444C25.6531 19.5289 25.677 19.5178 25.7023 19.5117Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4971 23.315C20.9565 23.2262 21.4031 23.0803 21.8267 22.8806C22.2508 22.6757 22.6423 22.4134 23.1073 22.1839L23.3847 21.9216L23.1808 22.2495C22.8137 22.5691 22.4873 22.9216 22.0958 23.2494C21.7006 23.5737 21.2679 23.8489 20.807 24.0691C20.7104 24.1059 20.6036 24.1052 20.5074 24.0672C20.4112 24.0292 20.3326 23.9565 20.2868 23.8635C20.2409 23.7704 20.2313 23.6635 20.2596 23.5636C20.2879 23.4637 20.3522 23.3781 20.44 23.3232C20.4588 23.3193 20.4779 23.3165 20.4971 23.315Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0127 23.2988C14.29 23.4054 14.5347 23.5119 14.7794 23.5939C15.0477 23.6716 15.32 23.7346 15.5951 23.7824C16.1334 23.878 16.6802 23.9165 17.2265 23.8972C16.6944 24.0522 16.1476 24.151 15.5951 24.1923C15.3071 24.2087 15.0185 24.2087 14.7305 24.1923C14.4287 24.1923 14.1432 24.1185 13.9148 24.0939C13.8057 24.0815 13.706 24.0264 13.6372 23.9404C13.5684 23.8544 13.5362 23.7446 13.5477 23.6349C13.5528 23.581 13.5685 23.5286 13.5939 23.4808C13.6192 23.433 13.6537 23.3907 13.6954 23.3565C13.7372 23.3222 13.7852 23.2965 13.8368 23.281C13.8885 23.2655 13.9427 23.2604 13.9964 23.2661C14.0286 23.2587 14.062 23.2587 14.0942 23.2661L14.0127 23.2988Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81648 19.4794L9.02041 19.8564L9.02041 19.8072C9.30586 20.1968 9.61077 20.5716 9.934 20.9302C10.2712 21.2791 10.6523 21.5822 11.0677 21.8318C10.5932 21.683 10.1385 21.4766 9.71374 21.217C9.28142 20.9466 8.89806 20.6105 8.51468 20.3154L8.51468 20.2662L8.2291 19.9548C8.15554 19.8744 8.11687 19.7678 8.12146 19.6587C8.12605 19.5496 8.17355 19.4467 8.25359 19.3728C8.33364 19.2989 8.43962 19.26 8.54823 19.2646C8.65684 19.2692 8.75916 19.317 8.83271 19.3974L8.81648 19.4794Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83411 13.3234L6.78512 13.7169C6.73594 14.5302 6.82989 15.346 7.06254 16.1266L7.20931 16.5447L6.96465 16.1758C6.53052 15.433 6.22701 14.6206 6.0674 13.7742L6.01841 13.3808C6.01158 13.3269 6.01546 13.2722 6.02986 13.2198C6.04426 13.1675 6.06885 13.1186 6.10225 13.0758C6.13565 13.0331 6.17721 12.9975 6.22443 12.9711C6.27164 12.9446 6.32356 12.9279 6.37727 12.9218C6.43106 12.9137 6.48602 12.9168 6.53858 12.9308C6.59115 12.9448 6.6403 12.9695 6.68306 13.0033C6.72582 13.037 6.76124 13.0792 6.78722 13.1272C6.81319 13.1752 6.82916 13.228 6.83411 13.2824L6.83411 13.3234Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1083_126755",
    x: 0,
    y: 0,
    width: 34.7295,
    height: 34.7292,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1083_126755"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1083_126755",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridImg1);
export default __webpack_public_path__ + "static/media/grid-img1.fa4b02d60ef6a8d258ad9cbde79b74d8.svg";
export { ForwardRef as ReactComponent };